// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1L7-B","container":"styles_container__14iGK","close":"styles_close__DF9RI"};